import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "运单信息", -1);
const _hoisted_2 = {
  class: "state-city_container"
};
const _hoisted_3 = {
  class: "state-city_container"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "订单信息", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "物流基本信息", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "当前物流信息", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "物流轨迹信息", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_base_table = _resolveComponent("base-table");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("section", null, [_createVNode(_component_el_scrollbar, {
    height: "700px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-width": "auto",
      model: $data.waybillForm,
      class: "waybill-form",
      style: {
        "width": "99%"
      }
    }, {
      default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "运单号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.waybill_no,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.waybillForm.waybill_no = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "邮编"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.postcode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.waybillForm.postcode = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "仓库"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.warehouse,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.waybillForm.warehouse = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "SKU"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.sku,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.waybillForm.sku = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "发货时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.shipping_time,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.waybillForm.shipping_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户国家"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.country,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.waybillForm.country = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户州"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.state,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.waybillForm.state = $event),
              disabled: ""
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.waybillForm.origin_state,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.waybillForm.origin_state = $event),
              disabled: ""
            }, null, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户城市"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.city,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.waybillForm.city = $event),
              disabled: ""
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.waybillForm.origin_city,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.waybillForm.origin_city = $event),
              disabled: ""
            }, null, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.address,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.waybillForm.address = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户姓名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.name,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.waybillForm.name = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户电话"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.phone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.waybillForm.phone = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "客户邮箱"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.email,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.waybillForm.email = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "备注信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.waybillForm.remark,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.waybillForm.remark = $event),
          type: "textarea",
          rows: 6,
          disabled: "",
          size: "small"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_divider), _hoisted_4, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "订单号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.order_no,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.waybillForm.order_no = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "平台"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.platform,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.waybillForm.platform = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "店铺"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.shop,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.waybillForm.shop = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "支付时间"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.waybillForm.payment_time,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.waybillForm.payment_time = $event),
          type: "datetime",
          disabled: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_divider), _hoisted_5, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "物流商"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.logistic_supplier,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.waybillForm.logistic_supplier = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "物流商官网链接"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.logistic_supplier_homepage,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.waybillForm.logistic_supplier_homepage = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "预计送达时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.estimated_delivery_time,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.waybillForm.estimated_delivery_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "首枪时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.receipt_time,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.waybillForm.receipt_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "首枪时效"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.receipt_days,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.waybillForm.receipt_days = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "送达时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.delivery_time,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.waybillForm.delivery_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "送达时效"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.waybillForm.delivery_days,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.waybillForm.delivery_days = $event),
          disabled: ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_divider), _hoisted_6, _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "获取状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.sync_state_desc,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.waybillForm.sync_state_desc = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "获取时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.sync_time,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.waybillForm.sync_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "运输状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.transit_state_desc,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.waybillForm.transit_state_desc = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "运输子状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.transit_sub_state_desc,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.waybillForm.transit_sub_state_desc = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最新轨迹停留时长"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.time,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.time = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最新轨迹时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.waybillForm.current_event_time,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.waybillForm.current_event_time = $event),
              type: "datetime",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最新轨迹地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.current_event_address,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.waybillForm.current_event_address = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 15
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "最新轨迹详情"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.waybillForm.current_event_detail,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.waybillForm.current_event_detail = $event),
              disabled: "",
              style: {
                "min-width": "600px !important"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_divider), _hoisted_7, _createVNode(_component_base_table, {
        "icon-visible": false,
        "index-visible": true,
        "selection-visible": false,
        "pagination-visible": false,
        "operation-visible": false,
        table: $options.table,
        type: "tracking"
      }, null, 8, ["table"]), _createVNode(_component_el_form_item, {
        class: "btn-position"
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      })]),
      _: 3
    }, 8, ["model"])]),
    _: 3
  })]);
}